<template>
    <div id="supplier_legal_representative_data" class="vx-col sm:w-5/6 md:w-2/3 lg:w-2/3 xl:w-3/5 xxl:w-2/3 m-0">
        <div class="vx-row no-gutter items-center justify-center p-6">
            <vx-card class="login-card py-3 px-3">
                <div slot="no-body" class="">
                    <div class="vx-col sm:w-full">
                        <div class="login-tabs-container">
                            <div class="vx-row m-0">
                                <div class="vx-col w-full pb-10 pt-10" style="min-height: 200px">
                                    <!-- MAIN-DIV -->
                                    <div v-if="isMainOnboardingStepVisible" class="px-6 pt-5 pb-5">
                                        <!-- HEADER -->
                                        <div class="vx-row mb-4 align-center">
                                            <div class="vx-col w-full">
                                                <h1 class="text-2xl card-sub-title">
                                                    {{ getSectionTitle }}
                                                </h1>
                                            </div>
                                        </div>
                                        <!-- CONTENT -->
                                        <div v-if="isMounted" class="main-form mt-base">
                                            <div class="vx-row">
                                                <div v-if="show_general_data(section.id)" v-for="section in allSections"
                                                    :key="section.id" :class="colClass">
                                                    <div class="mb-4">
                                                        <h6 :class="section.public_description != null ? 'mb-2' : ''">{{
                                                            section.public_name }}</h6>
                                                    </div>
                                                    <div class="vx-row">
                                                        <template v-for="f in section.fields">
                                                            <!-- Campos automaticos -->
                                                            <form-field :ref="`section_id_${section.id}`"
                                                                v-if="isAutoFormField(f)" :key="f.id" :f="f"
                                                                :dataContainer="getContainerForField(section, f)"
                                                                :collectionsRoot="collections"
                                                                :onChangeReceptor="onFieldChange"
                                                                :hasBackofficeAccess="false"
                                                                :blockedByDocument="f.blockedByDocument"
                                                                :evaluator="evaluateCondition" :inputClassLarge="true"
                                                                :countriesList="collections.countries"
                                                                :editableByBackoffice="true" />

                                                            <personal-profile-tins-control :key="f.id" :f="f"
                                                                :personal_profile_id="businessOwner.id"
                                                                ref="personal_profile_tins_component"
                                                                v-else-if="f.fname == 'owner_tins' && should_fill_owner_tins"
                                                                :disabled="f.blockedByDocument"
                                                                :countries="collections.countries" />

                                                        </template>
                                                    </div>
                                                </div>
                                            </div>
                                            <vs-alert v-if="errorMssg" icon-pack="feather" icon="icon-alert-triangle"
                                                class="mb-5" color="danger">
                                                <span class="font-regular">{{ errorMssg }}</span>
                                            </vs-alert>
                                            <vs-alert v-if="successMssg" icon-pack="feather" icon="icon-check" class="mb-5"
                                                color="success">
                                                <span class="font-regular">{{ successMssg }}</span>
                                            </vs-alert>
                                            <div class="vx-row mt-10">
                                                <div class="vx-col w-full">
                                                    <!-- BOTONES -->
                                                    <div class="flex justify-center">
                                                        <vs-button class="mt-2 vs-button-dark"
                                                            @click="saveSections(`section_id_${get_current_section}`)">Guardar</vs-button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- END CONTENT DIV -->
                                    </div>
                                    <!-- END MAIN-DIV -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </vx-card>
        </div>

        
        <role-integration-by-curp 
            v-if="showCurpMatchPopup"
            ref="RoleIntegrationByCurp"
            :matched-data="curpMatchedData" 
            :current-role="'Proveedor'"
            :model-to-update="UserId"
            :is-business="isMoral"
            :is-new-user="true"
        />
    </div>
</template>

<script>
import inputHelper from "@mixins/inputHelper";
import dateHelper from '@components/mixins/dateHelper';
import formatHelper from "@mixins/formatHelper";
import FormField from '@components/forms/FormField.vue';
import docsHelper from '@components/mixins/docsHelper';
import formHelper from '@components/mixins/formHelper';
import PersonalProfileTinsControl from '@supplier/PersonalProfileTinsControl.vue';
import RoleIntegrationByCurp from "../../../register/components/RoleIntegrationByCurp.vue";

const sectionsToContainers = [
    {
        id: 12, containers: [
            { db: 'personal_profiles', path: 'user.business.personal' },
            { db: 'phones', path: 'user.business.personal.phone', arrayDefs: { onNull: 'newPhone' } },
            { db: 'addresses', path: 'user.business.personal.address' },
            { db: 'business_profiles', path: 'user.business' },
            { db: 'business_profile_tins', path: 'user.business.tins', arrayDefs: {} },
            { db: 'personal_credit_profiles', path: 'user.business.personal.credit_profile' },
        ]
    },
    { id: 138, containers: [{ db: 'addresses', path: 'user.business.personal.address' }] },
    {
        id: 3, containers: [
            { db: 'personal_profiles', path: 'user.personal' },
            { db: 'suppliers', path: 'base' },
            { db: 'personal_credit_profiles', path: 'user.personal.credit_profile' },
            { db: 'phones', path: 'user.personal.phone', arrayDefs: { onNull: 'newPhone' } },
        ]
    },
    { id: 139, containers: [{ db: 'addresses', path: 'user.personal.address' }] },
];

export default {
    name: "SupplierOnboardingRepLegalData",
    mixins: [inputHelper, formatHelper, docsHelper, formHelper, dateHelper],
    components: {
        FormField,
        PersonalProfileTinsControl,
        RoleIntegrationByCurp,
    },
    props: ["onboardingStepData", "isMoral", "repLegalData"],
    data() {
        return {
            requiredRules: "required",
            errorMssg: null,
            successMssg: null,
            isMounted: false,
            loading: false,
            colClass: "vx-col w-full mb-5",
            requiredPlaceholder: "(Requerido)",
            isMainOnboardingStepVisible: true,
            formId: 2,
            pmSections: [12, 138],
            pfSections: [3, 139],
            form: {},
            allSections: [],
            formSections: [],

            documentsFields: [],
            documentsStates: [],

            validatedDocuments: [],
            allDocumentFields: [],
            // objeto principal
            base: {},
            // objetos para actualizaciones
            basePayload: {},
            validatedFields: [],
            totalFields: 0,
            totalValidFields: 0,
            totalInvalidFields: 0,
            skipMissingWarnings: false,
            collections: {
                countries: [],
                states_business_owner_personal_address: [],
                cities_business_owner_personal_address: [],
                neighborhoods_business_owner_personal_address: [],
                states_personal_business_owner_address: [],
                cities_personal_business_owner_address: [],
                neighborhoods_personal_business_owner_address: []
            },
            // auxiliares para evaluacion de condiciones
            mexicoCountryId: 700,
            isGeneralCompleted: false,
            isAddressCompleted: false,
            showCurpMatchPopup: false,
            curpMatchedData: {}
        };
    },
    async mounted() {
        this.isMounted = false;
        this.showLoading(true);
        this.base = this.onboardingStepData;
        await this.getCollections();
        await this.getSections();
        this.isMounted = true;
        this.showLoading(false);
    },
    computed: {
        personal() {
            return this.base.user.personal;
        },
        business() {
            return this.base.user.business;
        },
        businessOwner() {
            return this.base.user.business.personal;
        },
        should_fill_owner_rfc_curp_fiscal_rec() {
            return this.businessOwner.citizenship == this.mexicoCountryId;
        },
        should_fill_owner_tins() {
            return this.businessOwner.citizenship && this.businessOwner.citizenship != this.mexicoCountryId;
        },
        get_current_section() {
            const sections = this.isMoral ? this.pmSections : this.pfSections;
            if (!this.isGeneralCompleted) {
                return sections[0];
            } else {
                return sections[1];
            }
        },
        should_fill_personal_rfc(){
            return this.base.user.person_type == 1;
        },
        isPfae() {
            return this.base.user.person_type == 1;
        },
        getSectionTitle() {
            if(this.isMoral) {
                return "Datos del representante o apoderado legal";
            } else {
                return "Datos del responsable o dueño del negocio";
            }
        }
    },
    watch: {
        loading: function (newVal, oldVal) {
            if (newVal == true) {
                this.$vs.loading();
            }
            else {
                this.$vs.loading.close();
            }
        }
    },
    methods: {
        async getCollections() {
            try {
                let collectionsObjects = ['countriesList'];
                let params = "with[]=" + collectionsObjects.join("&with[]=");
                let res = await axios.get(`/api/v1/forms/getFormCollections?${params}`);
                let colls = res.data;
                this.collections.countries = colls.countriesList;
            } catch (e) {
                this.warn(e);
                this.failed = true;
            }
        },
        async getSections() {
            const sections = this.isMoral ? this.pmSections : this.pfSections;
            const res = await axios.post("/api/v1/forms/getSectionsByArrayIds", { section_ids: sections });
            this.allSections = res.data.sections;

            await this.asyncForEach(this.allSections, async (s) => {
                s.containers = this.getContainersForSection(s.id);
                s.documentFields = [];

                await this.asyncForEach(s.fields, async (f) => {
                    this.formFieldSetter(f, this);
                });
            });
        },
        getContainersForSection(section_id) {
            let c = sectionsToContainers.find(f => f.id == section_id);
            if (!c) {
                this.warn("Missing containers definition for section " + section_id);
                return null;
            }
            else {
                let sectionContainers = [];
                c.containers.forEach(cc => {
                    let con = this.setContainerFromDef(cc);
                    sectionContainers.push({ db: cc.db, path: cc.path, container: con });
                })
                return sectionContainers;
            }
        },
        getContainerForField(section, f) {
            let c = section.containers.find(sc => sc.db == f.db_table);
            if (!c) {
                this.warn(`Container not found for db [${f.fname}]: ${f.db_table}`);
                return null;
            }
            else {
                return c.container;
            }
        },
        setContainerFromDef(c) {
            let container = this.nestedFieldValue(this.base, c.path);
            if (Array.isArray(container)) {
                let ac = null;
                if (c.arrayDefs) {
                    if (c.arrayDefs.getFirst == true) {
                        ac = container[0];
                    }
                    else if (c.arrayDefs.eval) {
                        // llamado en funciones de secciones
                        ac = this[c.arrayDefs.eval](container);
                    }
                }
                if (!ac) {
                    if (c.arrayDefs.onNull) { ac = this[c.arrayDefs.onNull](); }
                    else { ac = {} }
                    container.push(ac);
                }
                return ac;
            }
            else {
                if (c.path == 'bank_accounts_bank') {
                    let accs = this.nestedFieldValue(this.base, 'user.business.bank_accounts');
                    let nbankAcc = accs[0];
                    return nbankAcc.bank;
                }
                if (container == null && c.arrayDefs) {
                    let ac = null;
                    if (c.arrayDefs.eval) {
                        // llamado en funciones de secciones
                        ac = this[c.arrayDefs.eval]();
                        return ac;
                    }
                    if (!ac) {
                        if (c.arrayDefs.onNull) { ac = this[c.arrayDefs.onNull](); }
                        else { ac = {} }
                        container = ac;
                    }
                }
                return container;
            }
        },
        /* evaluator */
        evaluateCondition(condition) {
            return this.evaluateConditionBase(this, condition);
        },
        /* on change receptor */
        onFieldChange(method) {
            if (method != null && method in this) {
                this[method]();
            }
        },
        newPhone() {
            return { country_calling_code: null, phone: null };
        },

        // GUARDAR
        async saveSections(gslug) {
            // this.loading = true;
            this.skipMissingWarnings = false;
            let result = await this.runValidations(gslug);
            if (!result) {
                if (!this.skipMissingWarnings) {
                    this.missingFieldsNotif();
                }
            } else {
                this.showLoading(true, "Guardando información...");
                //guardar solo la informacion que se ha modificado
                this.basePayload = this.collectFormData(gslug);
                if (this.objectIsEmpty(this.basePayload) && gslug != "knowledge") {
                    this.saveSuccessNotif();
                    await this.$emit("updated", 1);
                    this.updateGeneralCompleted();
                    this.isCompletedAll();
                    this.showLoading(false);
                    this.loading = false;
                    return;
                }

                this.basePayload.id = this.base.id;
                try {
                    // ejecutar guardado
                    this.injectAccountMetadataToPayload(this.basePayload);
                    await axios.put(`/api/v1/supplier/${this.SupplierId}/deepUpdate`, this.basePayload);
                    // solicitar la informacion actualizada del modelo
                    this.showLoading(false);
                    await this.$emit("updated", 1);
                    this.updateGeneralCompleted();
                    this.isCompletedAll();
                    this.saveSuccessNotif();
                }
                catch (error) {
                    this.showLoading(false);
                    this.warn(error);
                    this.failedOperationNotif(null, null);
                }
            }
            this.loading = false;
        },
        async runValidations(gslug) {
            // validar componentes tipo FormField
            let res1 = await this.validateFormFields(gslug);
            if (!res1) {
                return false;
            }

            // validar inputs instanciados en la vista
            let res2 = await this.$validator.validateAll();
            if (!res2) {
                return false;
            }

            // retornar true si todas las validaciones fueron positivas
            return true;
        },
        resetCounters() {
            this.totalFields = 0;
            this.totalValidFields = 0;
            this.totalInvalidFields = 0;
        },
        collectFormData(gslug) {
            let payload = {};
            const sectionId = gslug.substr(11);

            let section = this.allSections.find(s => s.id == sectionId);
            section.containers.forEach(cc => {
                let fields = this.validatedFields.filter(vf => vf.db == cc.db);
                if (fields.length < 1) {
                    return;
                }

                if (cc.path == "base") {
                    fields.forEach(f => {
                        payload[f.fname] = cc.container[f.fname];
                    });
                }
                else {
                    let obj = null;

                    obj = { id: cc.container.id };
                    fields.forEach(f => {
                        obj[f.fname] = cc.container[f.fname];
                    });

                    // ajuste para objetos tipo array
                    this.setDeepObjectWithIds(payload, this.base, cc.path, obj);
                }
            });
            return payload;
        },
        updateGeneralCompleted() {
            if (!this.isGeneralCompleted) {
                this.isGeneralCompleted = true;
            } else {
                this.updateAddressCompleted();
            }
        },
        updateAddressCompleted() {
            if (this.isGeneralCompleted && !this.isAddressCompleted) {
                this.isAddressCompleted = true;
            }
        },
        async isCompletedAll() {
            if(this.isGeneralCompleted && this.isAddressCompleted) {
                await this.$emit("completed", 1);
            }
        },
        async validateFormFields(refGroup) {
            let allValid = true;
            this.validatedFields = [];
            let grefs = this.$refs[refGroup];
            let f;
            for (let p in grefs) {
                f = grefs[p];
                let r = await f.checkForValidDirty();
                if (r.valid == false) {
                    allValid = false;
                }
                else if (r.dirty == true) {
                    let sp = f.specialValidation();
                    if (sp != null && sp.method in this) {
                        let res = await this[sp.method]();
                        let n = f.rawFieldName;
                        if (!res) {
                            if (f.db_name === "rfc" && res.length === 0) {
                                continue;
                            }
                            this.skipMissingWarnings = true;
                            allValid = false;
                            f.setError(sp.error);
                            this.errorNotif(n, sp.error, 10000);
                            continue;
                        }
                    }
                    this.validatedFields.push(r);
                }
            }
            return allValid;
        },
        verify_zip_code_business_owner_personal_address() {
            this.verifyZipCode(this.business.personal.address, {
                zipCodeVariable: 'zip_code_business_owner_personal_address',
                statesArray: 'states_business_owner_personal_address',
                citiesArray: 'cities_business_owner_personal_address',
                neighborhoodsArray: 'neighborhoods_business_owner_personal_address'
            });
        },
        set_zip_code_business_owner_personal_address() {
            this.setZipCodeAddressValues(this.business.personal.address_id, this.business.personal.address, {
                zipCodeVariable: 'zip_code_business_owner_personal_address',
                statesArray: 'states_business_owner_personal_address',
                citiesArray: 'cities_business_owner_personal_address',
                neighborhoodsArray: 'neighborhoods_business_owner_personal_address'
            });
        },

        verify_zip_code_personal_business_owner_address() {
            this.verifyZipCode(this.personal.address, {
                zipCodeVariable: 'zip_code_personal_business_owner_address',
                statesArray: 'states_personal_business_owner_address',
                citiesArray: 'cities_personal_business_owner_address',
                neighborhoodsArray: 'neighborhoods_personal_business_owner_address'
            });
        },
        set_zip_code_personal_business_owner_address() {
            this.setZipCodeAddressValues(this.personal.address_id, this.personal.address, {
                zipCodeVariable: 'zip_code_personal_business_owner_address',
                statesArray: 'states_personal_business_owner_address',
                citiesArray: 'cities_personal_business_owner_address',
                neighborhoodsArray: 'neighborhoods_personal_business_owner_address'
            });
        },
        /* validaciones especiales */
        validate_user_birthdate() {
            let years = this.calculateAgeFromDate(this.personal.birth_date);
            return years >= 18;
        },
        // validaciones
        validate_owner_birthdate() {
            let years = this.calculateAgeFromDate(this.businessOwner.birth_date);
            return years >= 18;
        },
        personal_curp_conditions_changed() {
            let c = this.personal.curp;
            if (!c) { return; }
            if (c.length >= 10) {
                let yy = c.slice(4, 6);
                let mm = c.slice(6, 8);
                let dd = c.slice(8, 10);

                let date = this.getDateFromInputs(yy, mm, dd);
                if (date === false) {
                    this.personal.birth_date = null;
                }
                else {
                    this.personal.birth_date = date;
                }
            }
            else {
                this.personal.birth_date = null;
            }

            if (c.length >= 11) {
                let g = c.slice(10, 11);
                if (g == "H") {
                    this.personal.gender = 1;
                }
                else if (g == "M") {
                    this.personal.gender = 2;
                }
                else {
                    this.personal.gender = null;
                }
            }
            else {
                this.personal.gender = null;
            }
        },
        owner_curp_conditions_changed() {
            let c = this.businessOwner.curp;
            if (!c) { return; }
            if (c.length >= 10) {
                let yy = c.slice(4, 6);
                let mm = c.slice(6, 8);
                let dd = c.slice(8, 10);

                let date = this.getDateFromInputs(yy, mm, dd);
                if (date === false) {
                    this.businessOwner.birth_date = null;
                }
                else {
                    this.businessOwner.birth_date = date;
                }
            }
            else {
                this.businessOwner.birth_date = null;
            }

            if (c.length >= 11) {
                let g = c.slice(10, 11);
                if (g == "H") {
                    this.businessOwner.gender = 1;
                }
                else if (g == "M") {
                    this.businessOwner.gender = 2;
                }
                else {
                    this.businessOwner.gender = null;
                }
            }
            else {
                this.businessOwner.gender = null;
            }
        },
        async validate_personal_unique_curp() {
            const uniqueCurp = await this.validate_unique_curp(this.personal.curp, this.personal.id);

            if(!uniqueCurp) {
                // Busca el curp para obtener el usuario asociado y su correo
                let curpMatchedData = await this.verify_curp_matches(this.personal.curp, this.personal.id);
                this.curpMatchedData = curpMatchedData;
                this.showCurpMatchPopup = true;

                this.$nextTick(() => {
                    this.$refs.RoleIntegrationByCurp.checkFlow();
                });
            }

            return uniqueCurp;

        },
        async validate_owner_unique_curp() {
            const uniqueCurp = await this.validate_unique_curp(this.businessOwner.curp, this.businessOwner.id);
            if(!uniqueCurp) {
                // Busca el curp para obtener el usuario asociado y su correo
                let curpMatchedData = await this.verify_curp_matches(this.businessOwner.curp, this.businessOwner.id);
                this.curpMatchedData = curpMatchedData;
                this.showCurpMatchPopup = true;

                this.$nextTick(() => {
                    this.$refs.RoleIntegrationByCurp.checkFlow();
                });
            }

            return uniqueCurp;
        },
        validate_personal_profile_tins() {
            if (this.$refs.personal_profile_tins_component[0] != null) {
                return this.$refs.personal_profile_tins_component[0].validate();
            }
            else {
                return true;
            }
        },
        validate_business_profile_tins() {
            if (this.$refs.business_profile_tins_component != null) {
                return this.$refs.business_profile_tins_component.validate();
            }
            else {
                return true;
            }
        },
        show_general_data(currentSectionId) {
            const sections = this.isMoral ? this.pmSections : this.pfSections;
            if (!this.isGeneralCompleted) {
                return currentSectionId == sections[0];
            } else {
                return currentSectionId == sections[1];
            }
        }
    },
};
</script>

<style>
.documents {
    border: 2px solid #c2c2c2;
    border-radius: 5px;
    padding: 2rem;
}

.documents ul {
    margin-left: 1rem;
}
</style>
